import img1 from "../../../assets/img/review/review1.png";
import img2 from "../../../assets/img/review/review2.png";
import img3 from "../../../assets/img/review/review3.png";

export const ReviewData = [
  {
    img: img1,
    date: "01 Jan 2025",
    status: "Excellent",
    name: "Ayesha Khan",
    des: "Traveler",
    review: `"The entire trip was well-organized, and every detail was taken care of. Highly recommended!"`,
  },
  {
    img: img2,
    date: "08 Jan 2025",
    status: "Excellent",
    name: "Mohammad Ali",
    des: "Businessman",
    review: `"Corporate travel services were efficient and stress-free. Will definitely book again!"`,
  },
  {
    img: img3,
    date: "3 Jan 2025",
    status: "Excellent",
    name: "Fatima Zafar",
    des: "Tourist",
    review: `"Amazing customer service and attention to detail. My family had a wonderful vacation!"`,
  },
  {
    img: img1,
    date: "19 Dec 2024",
    status: "Excellent",
    name: "Hamza Siddiqui",
    des: "Entrepreneur",
    review: `"The Umrah arrangements were exceptional. Everything was smooth and on time!"`,
  },
  {
    img: img2,
    date: "08 Dec 2024",
    status: "Excellent",
    name: "Zainab Ahmed",
    des: "Tourist",
    review: `"Our holiday package was perfect! The team made sure everything was planned wonderfully."`,
  },
  {
    img: img3,
    date: "01 Jan 2025",
    status: "Excellent",
    name: "Bilal Hussain",
    des: "Corporate Client",
    review: `"Visa facilitation services were excellent. The entire process was so smooth and hassle-free."`,
  },
  {
    img: img1,
    date: "30 Jul 2024",
    status: "Excellent",
    name: "Sara Malik",
    des: "Adventurer",
    review: `"The trip was unforgettable! From ticketing to hotels, everything was handled professionally."`,
  },
  {
    img: img2,
    date: "12 Jan 2025",
    status: "Excellent",
    name: "Yusuf Sheikh",
    des: "Businessman",
    review: `"Perfect travel management for corporate needs. Always reliable and professional!"`,
  },
  {
    img: img3,
    date: "09 Sep 2024",
    status: "Excellent",
    name: "Mariam Javed",
    des: "Traveler",
    review: `"Every aspect of our trip was carefully arranged. It made our vacation truly stress-free!"`,
  },
  {
    img: img1,
    date: "01 Oct 2024",
    status: "Excellent",
    name: "Omar Farooq",
    des: "Corporate Client",
    review: `"Hassle-free bookings and exceptional support throughout the journey. A fantastic experience!"`,
  },
  {
    img: img2,
    date: "18 Nov 2024",
    status: "Excellent",
    name: "Aminah Shah",
    des: "Tourist",
    review: `"A big thank you for arranging such a lovely holiday for us. Highly professional service!"`,
  },
  {
    img: img3,
    date: "27 Dec 2024",
    status: "Excellent",
    name: "Hasan Raza",
    des: "Traveler",
    review: `"Our family trip was perfectly managed. Would recommend their services to everyone!"`,
  },
  {
    img: img1,
    date: "10 Jan 2024",
    status: "Excellent",
    name: "Layla Tariq",
    des: "Adventurer",
    review: `"The team went above and beyond to make our trip memorable. Fantastic service!"`,
  },
  {
    img: img2,
    date: "19 Feb 2024",
    status: "Excellent",
    name: "Abdullah Khan",
    des: "Businessman",
    review: `"My business trip was managed seamlessly. They handled all the arrangements perfectly!"`,
  },
  {
    img: img3,
    date: "04 Mar 2024",
    status: "Excellent",
    name: "Nadia Anwar",
    des: "Tourist",
    review: `"Every detail of the trip was looked after, making it an unforgettable experience!"`,
  },
  {
    img: img1,
    date: "20 Apr 2024",
    status: "Excellent",
    name: "Hassan Ahmed",
    des: "Traveler",
    review: `"Professional, courteous, and reliable service. Highly recommended for travel needs!"`,
  },
  {
    img: img2,
    date: "15 May 2024",
    status: "Excellent",
    name: "Aliya Rizwan",
    des: "Tourist",
    review: `"The visa process was quick and hassle-free. I will definitely use their services again!"`,
  },
  {
    img: img3,
    date: "08 Jun 2024",
    status: "Excellent",
    name: "Saad Iqbal",
    des: "Corporate Client",
    review: `"They made my corporate travel experience so easy and efficient. Great service!"`,
  },
  {
    img: img1,
    date: "30 Jul 2024",
    status: "Excellent",
    name: "Aisha Noor",
    des: "Adventurer",
    review: `"The tour was well-organized, and every aspect was perfectly planned. Loved it!"`,
  },
  {
    img: img2,
    date: "18 Aug 2024",
    status: "Excellent",
    name: "Zafar Abbas",
    des: "Businessman",
    review: `"Their customer service and travel expertise are unmatched. Always a pleasure!"`,
  },
  {
    img: img3,
    date: "06 Sep 2024",
    status: "Excellent",
    name: "Amna Yusuf",
    des: "Tourist",
    review: `"The Hajj arrangements were handled with such care and professionalism. Thank you!"`,
  },
  {
    img: img1,
    date: "10 Oct 2024",
    status: "Excellent",
    name: "Tariq Mahmood",
    des: "Traveler",
    review: `"Exceptional planning and flawless execution. Highly satisfied with their services!"`,
  },
  {
    img: img2,
    date: "25 Nov 2024",
    status: "Excellent",
    name: "Rabia Hanif",
    des: "Tourist",
    review: `"They made our family trip so special. Great attention to detail and service!"`,
  },
  {
    img: img3,
    date: "15 Dec 2024",
    status: "Excellent",
    name: "Umar Khalid",
    des: "Corporate Client",
    review: `"Excellent corporate travel solutions. Always reliable and professional!"`,
  },
  {
    img: img1,
    date: "01 Jan 2025",
    status: "Excellent",
    name: "Zain Ali",
    des: "Traveler",
    review: `"Every moment of the trip was memorable. Thank you for such amazing arrangements!"`,
  },
];
